// I know we need to standaridise our code comments
// JavaScript function to handle onload events and register functions
document.addEventListener("DOMContentLoaded", function () {
  openButtonMenu();
  //preventDefaultOnClick();
  shiftFocusOnTab();
  addMenuButtonListener();
  // mobile menu accessibility
  setAriaAttributes();
  // updateAriaAttributes();
  // click active class toggle on submenu
  toggleActiveClassOnSubmenus();
  // lets make button menu accessible via tabs
  buttonMenuLastElementTabEventHandler();
  // mobile_menu_functionality();

  menuSearch();
  // handleMobileMegaMenu();
  mobileMegaMenuHamIconControl();
  handleFocusLevelThreeDesktop();
  bringFocusToSearchbarFull();
  changingImageOnHoverFocus();
  searchbarAccessibility();
  manageAriaLabels();
  mobileMenuAccessibility();
  mainMenuInitialFocus();
  handleHeaderEvents();
  preventDefaultOnClick();
});

window.addEventListener("resize", function () {
  preventDefaultOnClick();

});

// Function to open mobile menu
function openMobileMenu() {
  // Get the parent of parent of parent div with class 'mobile-menu'
  var mobileMenu = document.querySelector(".mobile-menu");

  // Add 'active' class on the mobile menu
  mobileMenu.classList.add("active");

  // Get the menu button
  var menuButton = document.querySelector(
    ".menu-action-buttons .mobile-menu-opener"
  );

  // Check if the mobile menu is active
  var isActive = mobileMenu.classList.contains("active");

  // Change aria labels for accessibility
  menuButton.setAttribute("aria-haspopup", isActive ? "true" : "false");
  menuButton.setAttribute("aria-expanded", isActive ? "true" : "false");

  // Add focus to the first anchor tag in the 'nav-container' after a delay
  setTimeout(function () {
    var firstAnchorInNavContainer = document.querySelector(".nav-container a");
    if (firstAnchorInNavContainer) {
      //   console.log(firstAnchorInNavContainer);
      firstAnchorInNavContainer.focus();
    }
  }, 100); // specify the delay here
}

// Add event listener to the menu button
function addMenuButtonListener() {
  // Get the menu button
  var menuButton = document.querySelector(
    ".menu-action-buttons .mobile-menu-opener"
  );

  // Check if the menu button exists to handle edge cases
  if (menuButton) {
    // Add event listener to the menu button
    menuButton.addEventListener("click", openMobileMenu);
  } else {
    //  console.log("Menu button not found");
  }
}

// Function to close mobile menu
function closeMobileMenu() {
  // Get the mobile menu by its class
  var mobileMenu = document.querySelector(".mobile-menu");

  // Check if the mobile menu exists to handle edge cases
  if (mobileMenu) {
    // Remove 'active' class from the mobile menu
    mobileMenu.classList.remove("active");
  }

  // Get the menu button
  var menuButton = document.querySelector(
    ".menu-action-buttons .mobile-menu-opener"
  );

  // Check if the menu button exists to handle edge cases
  if (menuButton) {
    // Change aria labels for accessibility
    menuButton.setAttribute("aria-haspopup", "false");
    menuButton.setAttribute("aria-expanded", "false");
  }
}

// Add event listener to the close button
// Quickly rewriting this to prevent error
// Use function or wrapper insted
const mobileMenuCloseButton = document.querySelector(
  ".mobile-menu-close-button a"
);
if (mobileMenuCloseButton) {
  mobileMenuCloseButton.addEventListener("click", closeMobileMenu);
}

function openButtonMenu() {
  // Get the menu button element
  var menuButton = document.querySelector(
    ".button-menu .menu-action-buttons a"
  );
  // Check if the menu button exists to avoid errors
  if (menuButton) {
    // Add a click event listener to the menu button
    menuButton.addEventListener("click", function (event) {
      // Prevent the default action
      event.preventDefault();
      let parent = event.target.parentNode.parentNode.parentNode;
      // Toggle the 'active' class on click
      parent.classList.toggle("active");

      // Check if the menu is now open or closed
      var isOpen = parent.classList.contains("active");

      // Set the ARIA attributes accordingly
      this.setAttribute("aria-expanded", isOpen);
      this.setAttribute("aria-label", isOpen ? "Close menu" : "Open menu");
    });
  }
}

// Function to prevent default action on click
function preventDefaultOnClick() {
  // Exit function if screen width is more than 960p
  // if (window.innerWidth > 960) {
    // Select all elements with the class '.menu-item-has-children' inside a 'header'
    let menuItems = document.querySelectorAll(
      ".desktop-menu .menu-item-has-children.level-1 > a"
    );
    if (!menuItems) {
      return false;
    }
   
for (let i = 0; i < menuItems.length; i++) {
  const item = menuItems[i];

  item.addEventListener("click", function (event) {
    event.preventDefault();

    const parent = this.parentNode;
    const wasActive = parent.classList.contains("active");

    // Remove active from all
    menuItems.forEach(el => el.parentNode.classList.remove("active"));

    // Toggle active only if it was not active before
    if (!wasActive) {
      parent.classList.add("active");
    }

 
  });

  // Handle Enter key for accessibility
  item.addEventListener("keydown", function (event) {
    if (event.key === "Enter" || event.keyCode === 13) {
      event.preventDefault();

      const parent = this.parentNode;
      const wasActive = parent.classList.contains("active");

      // Remove active from all
      menuItems.forEach(el => el.parentNode.classList.remove("active"));

      // Toggle active if not already active
      if (!wasActive) {
        parent.classList.add("active");
      }

    }
  });
}


  // }
  // else {
  //   let menuItems = document.querySelectorAll(
  //     "header .menu-item-has-children > a"
  //   );
  //   if (!menuItems) {
  //     return false;
  //   }
  //   for (var i = 0; i < menuItems.length; i++) {
  //     menuItems[i].addEventListener("click", function (event) {
  //       event.preventDefault();
  //     });
  //   }
  // }

}



// Function to shift focus on Tab key press
function shiftFocusOnTab() {
  // Select the element with the class '.mobile-menu-contact-us'
  var contactUs = document.querySelector(".mobile-menu-contact-us a");
  if (!contactUs) {
    return false;
  }
  // Add an event listener for the 'keydown' event
  contactUs.addEventListener("keydown", function (event) {
    // Check if the 'Tab' key was pressed
    if (event.key === "Tab" || event.keyCode === 9) {
      // Prevent the default action
      event.preventDefault();

      // Select the element with the class '.mobile-menu-close-button a'
      var closeButton = document.querySelector(".mobile-menu-close-button a");

      // Shift the focus to the close button
      closeButton.focus();
    }
  });
}

// Function to set initial ARIA roles and properties
// for mobile menu only
// Function to set initial ARIA roles and properties
function setAriaAttributes() {
  var menuItems = document.querySelectorAll(
    ".mobile-menu .menu-item-has-children, .button-menu .menu-item-has-children, .normal-menu .menu-item-has-children, .normal-colored-menu .menu-item-has-children"
  );
  menuItems.forEach(function (item) {
    if (item.querySelector(".sub-menu")) {
      item.setAttribute("aria-haspopup", "true");
      item.setAttribute("aria-expanded", "false");
    }
  });
}

// Function to update ARIA roles and properties on hover and focus
function updateAriaAttributes() {
  var menuItems = document.querySelectorAll(
    ".mobile-menu .menu-item-has-children, .button-menu .menu-item-has-children , .normal-menu .menu-item-has-children, .normal-colored-menu .menu-item-has-children"
  );
  menuItems.forEach(function (item) {
    item.addEventListener("mouseover", function () {
      if (item.querySelector(".sub-menu")) {
        item.setAttribute("aria-expanded", "true");
      }
    });
    item.addEventListener("mouseout", function () {
      if (item.querySelector(".sub-menu")) {
        item.setAttribute("aria-expanded", "false");
      }
    });
    item.addEventListener("click", function () {
      if (item.classList.contains("active")) {
        item.setAttribute("aria-expanded", "true");
      } else {
        item.setAttribute("aria-expanded", "false");
      }
    });
    item.addEventListener(
      "focus",
      function () {
        if (item.querySelector(".sub-menu")) {
          item.setAttribute("aria-expanded", "true");
        }
      },
      true
    );
    item.addEventListener(
      "blur",
      function () {
        if (item.querySelector(".sub-menu")) {
          item.setAttribute("aria-expanded", "false");
        }
      },
      true
    );
  });
}

// lets toggle active class on submenus for mobile menu only
function toggleActiveClassOnSubmenus() {
  var menuItems = document.querySelectorAll(
    ".mobile-menu .menu-item-has-children a"
  );
  const mobileMenuHeader = document.querySelector(".mega-menu-header");
  if (!mobileMenuHeader) {
    return false;
  }
  menuItems.forEach(function (item) {
    var submenu = item.parentNode.querySelector(".sub-menu");
    if (submenu) {
      // click event for sub menus
      item.addEventListener("click", function (event) {
        event.preventDefault();
        // Check if the submenu is currently visible
        // Toggle the visibility of the submenu
        // if (item.parentNode.classList.contains("active")) {
        //   item.parentNode.classList.remove("active");
        //   item.parentNode.classList.add("not-active");
        // } else {
        // item.parentNode.classList.remove("not-active");
        item.parentNode.classList.add("active");
        // }

        submenu.classList.add("active");
        if (submenu.classList.contains("level-1")) {
          mobileMenuHeader.classList.add("second-level-menu-open");

        }
        else if (submenu.classList.contains("level-2")) {
          mobileMenuHeader.classList.add("third-level-menu-open");

        }
        // remove this class when second level or first level menu closes only (Not third)
        mobileMenuHeader.classList.add("second-level-menu");
        // submenu.style.display = isSubmenuVisible ? "none" : "block";
      });
      // emter event for sub menu to open
      item.addEventListener("keydown", function (event) {
        if (event.key === 'Enter') {
          event.preventDefault();
          // Check if the submenu is currently visible
          //var isSubmenuVisible = submenu.style.display === "block";
          // Toggle the visibility of the submenu
          // if (item.parentNode.classList.contains("active")) {
          //   item.parentNode.classList.remove("active");
          //   item.parentNode.classList.add("not-active");
          // } else {
          // item.parentNode.classList.remove("not-active");
          item.parentNode.classList.add("active");
          item.parentNode.setAttribute("aria-expanded", "true");
          // }

          submenu.classList.toggle("active");
          if (submenu.classList.contains("level-1")) {
            mobileMenuHeader.classList.add("second-level-menu-open");
            let firstanchor = submenu.querySelector("a");
            if (firstanchor) {
              let firstChild = firstanchor.closest(".submenu-wrapper").querySelector("a");
              if (firstChild) {
                setTimeout(function () {
                  firstChild.focus();
                }, 10);
              }
            }
          }
          else if (submenu.classList.contains("level-2")) {
            mobileMenuHeader.classList.add("third-level-menu-open");
            let firstanchor = submenu.parentNode.querySelector("a");
            if (firstanchor) {
              setTimeout(function () {
                firstanchor.focus();
              }, 10);
            }
          }
          // remove this class when second level or first level menu closes only (Not third)
          mobileMenuHeader.classList.add("second-level-menu");
          //   submenu.style.display = isSubmenuVisible ? "none" : "block";
        }

      });
    }
  });
}

// lets make button menu accessible via tabs

function buttonMenuLastElementTabEventHandler() {
  var buttonMenu = document.querySelectorAll(".button-menu .menu-item a");
  if (!buttonMenu) {
    return false;
  }
  var lastButtonMenu = buttonMenu[buttonMenu.length - 1];
  var buttonToOpenMenu = document.querySelector(".menu-action-buttons a");
  if (!buttonToOpenMenu) {
    return false;
  }
  if (!lastButtonMenu) {
    return false;
  }
  lastButtonMenu.addEventListener("keydown", function (e) {
    var key = e.which || e.keyCode;
    if (key === 9) {
      // 9 is the keyCode for the Tab key
      e.preventDefault();
      buttonToOpenMenu.focus();
    }
  });
}


function mainMenuInitialFocus() {
  const logoDiv = document.querySelector('header .site-branding a');
  const desktopMenuLinks = document.querySelectorAll('header .desktop-menu a');
  const searchSubmitInput = document.querySelector('header .search-submit');

  if (window.innerWidth > 960) {
    logoDiv.addEventListener('keydown', function (event) {
      if (event.key === 'Tab' && !event.shiftKey) {
        event.preventDefault();
        desktopMenuLinks[0].focus();
      }
    });

    desktopMenuLinks[desktopMenuLinks.length - 1].addEventListener('keydown', function (event) {
      if (event.key === 'Tab' && !event.shiftKey) {
        event.preventDefault();
        searchSubmitInput.focus();
      }
    });
  }
}

// Function for search functionality
function menuSearch() {
  let menu_search_icon = document.querySelector(".mega-menu-header .mega-menu .search-menu");
  let mega_menu_header = document.querySelector(".mega-menu-header");
  let desktop_menu = document.querySelector(".mega-menu-header .row.two-col.mega-menu ul.mega-menu");
  let menu_search_input = document.querySelector(".mega-menu-header .mega-menu .search-menu .search-field");
  if (mega_menu_header) {
    if (menu_search_icon) {
      // Toggle class when the search icon is clicked
      menu_search_icon.addEventListener("click", function (event) {
        event.stopPropagation(); // Prevent click from propagating to document

        // Toggle 'active-search' class on the search icon
        if (menu_search_icon.classList.contains("active-search")) {
          menu_search_icon.classList.remove("active-search"); // Remove class if already active
          desktop_menu.style.visibility = "visible";
        } else {
          menu_search_icon.classList.add("active-search"); // Add class if not active
          desktop_menu.style.visibility = "hidden";
        }
      });

      // Listen for clicks anywhere on the document
      document.addEventListener("click", function (event) {
        // Check if the click occurred outside the mega menu header and search form
        if (!mega_menu_header.contains(event.target)) {
          menu_search_icon.classList.remove("active-search"); // Close the search form
          desktop_menu.style.visibility = "visible"; // Show the main menu
        }
      });

      // Prevent clicks inside the search input from closing the menu
      menu_search_input.addEventListener("click", function (event) {
        event.stopPropagation(); // Prevent the click from propagating and triggering the document click listener
      });
    }
  }
}

// function seems to be for mobile menu only
function mobileMegaMenuHamIconControl() {

  // full menu active class active-mobile-menu
  // hamicon for second and third level class second-level-menu

  // Select all required elements
  const mobileMenuHeader = document.querySelector(".mega-menu-header");
  const mobileHamicon = document.querySelector(".menu-icon .hamicon");
  const mobileNavContainer = document.querySelector(
    ".mobile-menu .nav-container"
  );

  // Check if required elements exist
  if (mobileMenuHeader && mobileHamicon && mobileNavContainer) {
    // Hamburger Icon Click Logic
    mobileHamicon.addEventListener("click", function () {

      if (mobileMenuHeader.classList.contains("third-level-menu-open")) {
        // close third level menu
        closeSecondThirdLevelMenu(2);
        // remove this class
        mobileMenuHeader.classList.remove("third-level-menu-open");
      }
      else if (mobileMenuHeader.classList.contains("second-level-menu-open")) {
        // close second level menu
        closeSecondThirdLevelMenu(1);
        // remove this class
        mobileMenuHeader.classList.remove("second-level-menu-open");
        // remove second-level-menu class
        mobileMenuHeader.classList.remove("second-level-menu");
      }
      else if (mobileMenuHeader.classList.contains("active-mobile-menu")) {
        // close first level menu
        closeMainMenu();
        // remove this class
        mobileMenuHeader.classList.remove("active-mobile-menu");
      }
      else {
        // open first level menu
        openMainMenu();
      }

    });

    // keydown logic
    mobileHamicon.addEventListener("keydown", function () {
      if (event.key === 'Enter') {
        if (mobileMenuHeader.classList.contains("third-level-menu-open")) {
          // close third level menu
          closeSecondThirdLevelMenu(2);
          // remove this class
          mobileMenuHeader.classList.remove("third-level-menu-open");
        }
        else if (mobileMenuHeader.classList.contains("second-level-menu-open")) {
          // close second level menu
          closeSecondThirdLevelMenu(1);
          // remove this class
          mobileMenuHeader.classList.remove("second-level-menu-open");
          // remove second-level-menu class
          mobileMenuHeader.classList.remove("second-level-menu");
        }
        else if (mobileMenuHeader.classList.contains("active-mobile-menu")) {
          // close first level menu
          closeMainMenu();
          // remove this class
          mobileMenuHeader.classList.remove("active-mobile-menu");
        }
        else {
          // open first level menu
          openMainMenu();
        }
      }
    }
    );

    // Functions to manage menu states
    function openMainMenu() {
      mobileNavContainer.style.display = "block";
      mobileMenuHeader.classList.add("active-mobile-menu");
      mobileHamicon.setAttribute("aria-label", "Close the menu");
    }

    function closeMainMenu() {
      mobileNavContainer.style.display = "none";
      mobileMenuHeader.classList.remove("active-mobile-menu");
      mobileHamicon.setAttribute("aria-label", "Open the menu");
    }


    function closeSecondThirdLevelMenu(level = 1) {
      if (level == 1) {
        try {
          const activeMenuItems = document.querySelectorAll(".menu-item.level-1.active");
          if (activeMenuItems.length > 0) {
            activeMenuItems.forEach(item => {
              item.classList.remove("active");
              item.setAttribute("aria-expanded", "false");
              const subMenu = item.closest(".sub-menu");
              if (subMenu) {
                subMenu.classList.remove("active");
              }
            });
          } else {
            //   console.warn("No active menu items found.");
          }
        } catch (error) {
          //   console.error("An error occurred while removing the 'active' class:", error);
        }
      }
      else {
        try {
          const activeMenuItems = document.querySelectorAll(".menu-item.level-2.active");
          if (activeMenuItems.length > 0) {
            activeMenuItems.forEach(item => {
              item.classList.remove("active");
              item.setAttribute("aria-expanded", "false");
              const subMenu = item.closest(".sub-menu");
              if (subMenu) {
                subMenu.classList.remove("active");
              }
            });
          } else {
            //  console.warn("No active menu items found.");
          }
        } catch (error) {
          //  console.error("An error occurred while removing the 'active' class:", error);
        }
      }
    }
  }

}


// function to change skeleton images in header based on mouseover event for desktop only
function changingImageOnHoverFocus() {
  // Function to handle mouseover and focus events for submenu-wrapper links
  function handleMouseoverAndFocus(event) {
    // Ensure the event target is the anchor element itself
    if (event.target === event.currentTarget) {
      const skeletonImgValue = event.currentTarget.getAttribute('data-skeleton-img') ?? siteData.themeUri + "/dist/images/default-page-preview.webp";
      const skeletonImgTitle = event.currentTarget.querySelector(".title");
      let skeletonTitle = "Page preview";

      if (skeletonImgTitle) {
        // Replace title
        skeletonTitle = skeletonImgTitle.textContent + " page preview"; // Example of replacing the title
      }

      // Use closest() to find the nearest .skeleton-image-wrapper ancestor
      const submenuWrapper = event.currentTarget.closest(".submenu-wrapper");
      const skeletontitle = submenuWrapper ? submenuWrapper.querySelector('.skeletontitle') : null;
      const imageElement = submenuWrapper ? submenuWrapper.querySelector('.skeleton-image-wrapper img') : null;

      if (imageElement) {
        imageElement.src = skeletonImgValue;
        imageElement.alt = skeletonTitle;
      }

      if (skeletontitle) {
        skeletontitle.textContent = skeletonTitle;
      }
    }
  }

  // Function to handle mouseover and focus events for mega-menu level-1 links
  function handleMegaMenuMouseoverAndFocus(event) {
    // Ensure the event target is the anchor element itself
    if (event.target === event.currentTarget) {
      const skeletonImgValue = event.currentTarget.getAttribute('data-skeleton-img') ?? siteData.themeUri + "/dist/images/default-page-preview.webp";
      const skeletonImgTitle = event.currentTarget.querySelector(".title");
      let skeletonTitle = "Page preview";

      if (skeletonImgTitle) {
        // Replace title
        skeletonTitle = skeletonImgTitle.textContent + " page preview"; // Example of replacing the title
      }

      // Use closest() to find the nearest .skeleton-image-wrapper ancestor
      const megaMenuWrapper = event.currentTarget.closest(".menu-item");
      const skeletontitle = megaMenuWrapper ? megaMenuWrapper.querySelector('.skeletontitle') : null;
      const imageElement = megaMenuWrapper ? megaMenuWrapper.querySelector('.skeleton-image-wrapper img') : null;

      if (imageElement) {
        imageElement.src = skeletonImgValue;
        imageElement.alt = skeletonTitle;
      }

      if (skeletontitle) {
        skeletontitle.textContent = skeletonTitle;
      }
    }
  }

  // Function to add event listeners to submenu-wrapper links
  function addSubmenuEventListeners() {
    const links = document.querySelectorAll('.submenu-wrapper .level-2>a, .submenu-wrapper .level-3>a');
    links.forEach(link => {
      link.addEventListener('mouseover', handleMouseoverAndFocus);
      link.addEventListener('focus', handleMouseoverAndFocus);
    });
  }

  // Function to add event listeners to mega-menu level-1 links
  function addMegaMenuEventListeners() {
    const links = document.querySelectorAll('.mega-menu .level-1>a');
    links.forEach(link => {
      link.addEventListener('mouseover', handleMegaMenuMouseoverAndFocus);
      link.addEventListener('focus', handleMegaMenuMouseoverAndFocus);
    });
  }

  // Check screen width and add event listeners if width > 960px
  if (window.innerWidth > 960) {
    addSubmenuEventListeners();
    addMegaMenuEventListeners();
  }

  // Re-check screen width on resize and add/remove event listeners accordingly
  window.addEventListener('resize', function () {
    if (window.innerWidth > 960) {
      addSubmenuEventListeners();
      addMegaMenuEventListeners();
    } else {
      // Remove event listeners if screen width <= 960px
      const submenuLinks = document.querySelectorAll('.submenu-wrapper .level-2>a, .submenu-wrapper .level-3>a');
      submenuLinks.forEach(link => {
        link.removeEventListener('mouseover', handleMouseoverAndFocus);
        link.removeEventListener('focus', handleMouseoverAndFocus);
      });

      const megaMenuLinks = document.querySelectorAll('.mega-menu .level-1>a');
      megaMenuLinks.forEach(link => {
        link.removeEventListener('mouseover', handleMegaMenuMouseoverAndFocus);
        link.removeEventListener('focus', handleMegaMenuMouseoverAndFocus);
      });
    }
  });
}

// function handle third level menu on focus on desktop

function handleFocusLevelThreeDesktop() {
  // Function to handle focus events
  function handleFocus(event) {
    const parentLi = event.currentTarget.closest('li');
    if (parentLi) {
      // Remove hover class from all sibling li elements
      const siblingLis = parentLi.parentElement.children;
      for (let sibling of siblingLis) {
        if (sibling !== parentLi) {
          sibling.classList.remove('hover');
        }
      }
      // Add hover class to the focused li element
      parentLi.classList.add('hover');
    }
  }

  // Function to handle blur events
  function handleBlur(event) {
    const parentLi = event.currentTarget.closest('li');
    setTimeout(() => {
      if (parentLi && !parentLi.contains(document.activeElement)) {
        parentLi.classList.remove('hover');
      }
    }, 0);
  }

  // Function to add event listeners to level-2 <a> elements inside .submenu-wrapper
  function addEventListeners() {
    const links = document.querySelectorAll('.submenu-wrapper .sub-menu.level-1.has-level-two .level-2>a');
    links.forEach(link => {
      link.addEventListener('focus', handleFocus);
      link.addEventListener('blur', handleBlur);
    });
  }

  // Function to remove event listeners from level-2 <a> elements inside .submenu-wrapper
  function removeEventListeners() {
    const links = document.querySelectorAll('.submenu-wrapper .sub-menu.level-1.has-level-two .level-2>a');
    links.forEach(link => {
      link.removeEventListener('focus', handleFocus);
      link.removeEventListener('blur', handleBlur);
    });
  }

  // Check screen width and add event listeners if width > 960px
  if (window.innerWidth > 960) {
    addEventListeners();
  }

  // Re-check screen width on resize and add/remove event listeners accordingly
  window.addEventListener('resize', function () {
    if (window.innerWidth > 960) {
      addEventListeners();
    } else {
      removeEventListeners();
    }
  });
}

// Function to bring focus to search bar, for desktop only
function bringFocusToSearchbarFull() {
  // Function to handle keydown event on the last element of the mega menu
  function handleTabPress(event) {
    if (event.key === 'Tab' && !event.shiftKey) {
      // Prevent default tab behavior
      event.preventDefault();
      // Focus on the input field of the search menu form
      const searchInput = document.querySelector('.search-menu form input[type="button"]');
      if (searchInput) {
        searchInput.focus();
      }
    }
  }

  function bringFocusToSearchbar() {
    // Select the last element of the mega menu
    const lastMegaMenuItem = document.querySelector('.mega-menu .level-1:last-child > a');
    if (lastMegaMenuItem) {
      lastMegaMenuItem.addEventListener('keydown', handleTabPress);
    }
  }

  // Check screen width and add event listeners if width > 960px
  if (window.innerWidth > 960) {
    bringFocusToSearchbar();
  }

  // Re-check screen width on resize and add/remove event listeners accordingly
  window.addEventListener('resize', function () {
    if (window.innerWidth > 960) {
      bringFocusToSearchbar();
    } else {
      // Remove event listeners if screen width <= 960px
      const lastMegaMenuItem = document.querySelector('.mega-menu .level-1:last-child > a');
      if (lastMegaMenuItem) {
        lastMegaMenuItem.removeEventListener('keydown', handleTabPress);
      }
    }
  });
}

// function to make search bar accessible via keyboard for desktop only
function searchbarAccessibility() {
  // if (window.innerWidth > 960) {
  const searchMenu = document.querySelector('.search-menu');
  const searchInput = document.querySelector('.search-menu .search-field');
  const searchButton = document.querySelector('.search-menu .search-submit');

  // Function to handle keydown event
  function handleKeydown(event) {
    if (event.key === 'Enter') {
      if (document.activeElement === searchButton && searchMenu.classList.contains('active-search')) {
        // Prevent default behavior if Enter is pressed on the button and search menu is active
        //event.preventDefault();

      } else {
        // Move focus to the search input field on the first Enter key press
        //  event.preventDefault();
        setTimeout(function () {
          searchButton.setAttribute('aria-label', 'Close search bar');
          searchInput.focus();
        }, 10);

      }
    }
    if (event.key === 'Tab' && !event.shiftKey) {
      if (document.activeElement === searchButton && !searchMenu.classList.contains('active-search')) {
        // Prevent default behavior if Enter is pressed on the button and search menu is active
        //event.preventDefault();

        const focusableElements = 'a:not(.ps-play-pause), button, input, textarea, select, details, [tabindex]:not([tabindex="-1"])';
        const siteContent = document.querySelector('.site-content');
        const siteFooter = document.querySelector('.site-footer');
        const bannerButton = document.querySelector(".hero_buttons a.scroll-banner-btn");
        if (bannerButton) {
          setTimeout(() => {
            bannerButton.focus();
          }, 10);
        }
        let firstFocusableElement = null;

        if (siteContent) {
          firstFocusableElement = siteContent.querySelector(focusableElements);
        }

        if (!firstFocusableElement && siteFooter) {
          firstFocusableElement = siteFooter.querySelector(focusableElements);
        }

        if (firstFocusableElement) {
          firstFocusableElement.focus();


        }
      }
    }
  }
  // Function to handle keydown tab event
  function handleTabKeydownSearch(event) {
    if (event.key === 'Tab' && !event.shiftKey) {
      setTimeout(function () {

        searchButton.focus();
      }, 10);


    }
  }
  // Add keydown event listener to the document
  searchButton.addEventListener('keydown', handleKeydown);
  searchInput.addEventListener('keydown', handleTabKeydownSearch);

  // Add basic accessibility features
  searchInput.setAttribute('aria-label', 'Search input');
  searchButton.setAttribute('aria-label', 'Open search bar');
  // }
}

// function to manage aria labels for desktop only
function manageAriaLabels() {
  // Function to handle focus events
  function handleFocus(event) {
    const parentLi = event.currentTarget.closest('li.menu-item-has-children');
    if (parentLi) {
      parentLi.setAttribute('aria-expanded', 'true');
    }
  }

  // Function to handle blur events
  function handleBlur(event) {
    const parentLi = event.currentTarget.closest('li.menu-item-has-children');
    setTimeout(() => {
      if (parentLi && !parentLi.contains(document.activeElement)) {
        parentLi.setAttribute('aria-expanded', 'false');
      }
    }, 0);
  }

  // Function to add event listeners to menu items with children
  function addEventListeners() {
    const menuItems = document.querySelectorAll('.desktop-menu .menu-mega-menu li.menu-item-has-children > a');
    menuItems.forEach(item => {
      item.addEventListener('focus', handleFocus);
      item.addEventListener('blur', handleBlur);
    });
  }

  // Function to remove event listeners from menu items with children
  function removeEventListeners() {
    const menuItems = document.querySelectorAll('.desktop-menu .menu-mega-menu li.menu-item-has-children > a');
    menuItems.forEach(item => {
      item.removeEventListener('focus', handleFocus);
      item.removeEventListener('blur', handleBlur);
    });
  }

  // Check screen width and add event listeners if width > 960px
  if (window.innerWidth > 960) {
    addEventListeners();
  }

  // Re-check screen width on resize and add/remove event listeners accordingly
  window.addEventListener('resize', function () {
    if (window.innerWidth > 960) {
      addEventListeners();
    } else {
      removeEventListeners();
    }
  });
}


// Function to make mobile menu accessible
function mobileMenuAccessibility() {
  if (window.innerWidth < 960) {
    const hamIcon = document.querySelector('.hamicon');
    const menuContainer = document.querySelector('nav.menu-mobile-menu');
    const header = document.querySelector('.site-header');

    if (!hamIcon || !menuContainer || !header) {
      return;
    }

    const lastMenuLinks = menuContainer.querySelectorAll('ul.level-1 > li:last-child > a, ul.level-2 > li:last-child > a, ul.mega-menu li:last-child > a');

    lastMenuLinks.forEach(link => {
      link.addEventListener('keydown', function (event) {
        if (event.key === 'Tab' && !event.shiftKey) {
          event.preventDefault();
          hamIcon.focus();
        }
      });
    });

    hamIcon.addEventListener('keydown', function (event) {
      if (event.key === 'Tab' && !event.shiftKey) {
        if (header.classList.contains('third-level-menu-open')) {
          const firstLevel2Link = header.querySelector('.active.level-2 .submenu-wrapper-level2 a');
          if (firstLevel2Link) {
            event.preventDefault();
            firstLevel2Link.focus();
          }
        } else if (header.classList.contains('second-level-menu-open')) {
          const firstLevel1Link = header.querySelector('li.level-1.active .submenu-wrapper a');
          if (firstLevel1Link) {
            event.preventDefault();
            firstLevel1Link.focus();
          }
        }
        else if (header.classList.contains('active-mobile-menu')) {
          const firstLevel1Link = header.querySelector('.mobile-menu li.level-1.menu-item a');

          if (firstLevel1Link) {
            event.preventDefault();
            setTimeout(() => {

              firstLevel1Link.focus();
            }, 10);
          }
        }
        else {
          event.preventDefault();
          const links = document.querySelector('.search-menu .search-form .search-submit');
          setTimeout(() => {
            links.focus();

          }, 10);
        }
      }
    });
  }
}


function handleHeaderEvents() {
  const body = document.body;
  const header = document.querySelector('header.mega-menu-header');

  if (window.innerWidth > 0 && body.classList.contains('transparent_header_sellafield')) {
    header.addEventListener('mouseover', function () {
      body.classList.remove('transparent_header_sellafield');
    });

    header.addEventListener('mouseout', function () {
      body.classList.add('transparent_header_sellafield');
    });

    header.addEventListener('focusin', function () {
      body.classList.remove('transparent_header_sellafield');
    });

    header.addEventListener('focusout', function () {
      body.classList.add('transparent_header_sellafield');
    });
  }
}